import { ContractType } from "./contract";
import { OfferTypeEnum } from "./offerType";

export enum CustomFieldType {
    String = 1,
    Int = 2,
    Decimal = 3,
    Date = 4,
    DateTime = 5,
    DateRange = 6,
    SingleSelect = 7,
    MultiSelect = 8
}

export interface CustomField {
    id: string;
    erpId: string;
    name: string;

    group?: CustomFieldGroup;
    type: CustomFieldType;

    allowPurchase: boolean;
    allowSale: boolean;

    minValue?: string;
    maxValue?: string;

    defaultValue?: string;
    sortOrder: number;
    isRequired: boolean;
    erpFormat?: string;
    mappedField?: string;

    allowedOptions: CustomFieldOption[];
    allowedOfferTypes: OfferTypeEnum[];
    allowedContractTypes: ContractType[];
    allowedCommodities: number[];
}

export interface CustomFieldGroup {
    id: number;
    name: string;
    sortOrder: number;
}

export class CustomFieldThin {
    id: string = null;
    name: string = null;
    value: string = null;
}

export class CustomFieldOption {
    erpId: string = null;
    description: string = null;
    sortOrder: number;
}